import * as React from "react";

const Star = (props) => (
  <svg
    width={props.width || "1em"}
    height={props.height || "1em"}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.3336 4.78422L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422ZM6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397L6.50994 4.98442Z"
      fill="currentColor"
    />
  </svg>
);

export default Star;
